import React, { FC } from 'react'
import polaroidStyles from '../Polaroid.module.scss'
import classNames from 'classnames'
import Skeleton from 'components/SA/Skeleton'
import useQA from 'hooks/useQA'
import styles from '../PolaroidList.module.scss'

type PolaroidSkeletonProps = {
  customClassName?: string
  width?: number
  height?: number
}

type PolaroidListSkeletonProps = {
  customStyle?: string
  skeletonQuantity?: number
}

export const PolaroidCompleteSkeleton = () => {
  return (
    <div className={classNames(polaroidStyles.polaroidSkeletonContainer)}>
      <Skeleton width='100%' height='484px' />
      <Skeleton width='100%' height='26px' />
      <Skeleton width='100%' height='22px' />
      <Skeleton width='100%' height='18px' />
      <Skeleton width='100%' height='18px' />
      <Skeleton width='100%' height='18px' />
    </div>
  )
}

export const PolaroidSkeleton: FC<PolaroidSkeletonProps> = ({
  customClassName = '',
  width,
  height,
}) => {
  return (
    <div
      className={classNames(polaroidStyles.polaroidSkeletonContainer, {
        [customClassName]: customClassName !== '',
      })}
    >
      <Skeleton width={`${width}px`} height={`${height}px`} />
    </div>
  )
}

export const PolaroidListSkeleton: FC<PolaroidListSkeletonProps> = ({
  customStyle = '',
  skeletonQuantity = 6,
}) => {
  const { testId } = useQA()
  return (
    <div
      className={classNames(styles.polaroidListContainer, {
        [customStyle]: customStyle !== '',
      })}
      {...testId('polaroid-list-container-loading')}
    >
      {Array.from({ length: skeletonQuantity }, (_, index) => (
        <PolaroidCompleteSkeleton key={index.toString()} />
      ))}
    </div>
  )
}
